export enum HttpAuthentication {
  NONE = 'NONE',
  BASIC = 'BASIC',
  BEARER = 'BEARER',
  OAUTH_CLIENT_CREDENTIALS = 'OAUTH_CLIENT_CREDENTIALS',
  OAUTH_CLIENT_CREDENTIALS_BASIC_AUTH = 'OAUTH_CLIENT_CREDENTIALS_BASIC_AUTH',
}

export interface HttpConfiguration {
  url: string;

  authentication: HttpAuthentication;

  username?: string;

  password?: string;

  token?: string;

  jobListEndpoint?: string;

  clientId?: string;

  clientSecret?: string;

  tokenUrl?: string;

  scope?: string;

  useXSRFToken?: boolean;

  xsrfTokenHeader?: string;
}
